module.exports = __webpack_public_path__ + "static/media/favoris - Copy.9aaf9b73.jpg";